<template>
    <div>

        <el-tabs v-model="tabsKey" @tab-click="handleClick">
            <el-tab-pane label="查詢" name="search">
                <search @detailTabs="detailTabs" />
            </el-tab-pane>
            <el-tab-pane label="詳細" name="detail" v-if="isShowDetail" >
                <detail :orderKey="orderKey" @chreListTabs="chreListTabs" />
            </el-tab-pane>
              <el-tab-pane label="退換貨記錄" name="chrelist" v-if="isShowList">
                <chrelist :orderKey="orderKey" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
 import search from './OrderReturn/search'
 import detail from './OrderReturn/detail'
 import chrelist from './OrderReturn/chrelist'
    export default {
        name: 'orderReturn',
        components: {
            search,
            detail,
            chrelist
        },
        data() {
            return {
                isShowDetail: false,
                isShowList: false,
                tabsKey: 'search',
                orderKey: ''
            }
        },
        methods: {
            detailTabs(orderKey){
                this.isShowDetail = true
                this.isShowList = false
                this.tabsKey ="detail"
                this.orderKey = orderKey
            },
              chreListTabs(orderKey){
                this.isShowList = true
                this.tabsKey = "chrelist"
                this.orderKey = orderKey
            },
            handleClick(tab, event){
                if (tab.name == 'search') {
                    this.isShowDetail = false
                    this.isShowList = false
                }
            },
            back(){
                this.isShowDetail = false
            }
        },
    }
</script>

<style lang="scss" scoped>
    #tab-search {
       font-size: 16px;
       font-weight: bold;
    }
</style>